import { Box, Popover } from '@mui/material';
import { useState, FC } from 'react';
import { ReactComponent as InfoIcon } from '../../assets/images/info.svg';
import HoursOutTooltip from './HoursOutTooltip';
import { Activity } from '../../services/configApi/activitySheet/weeklyActivitySheetProvider';

interface HoursOutPopoverProps {
  activity: Activity;
}

const HoursOutPopover: FC<HoursOutPopoverProps> = ({ activity }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '4px',
        cursor: 'pointer',
      }}
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      <InfoIcon stroke="var(--thom-mono-gray)" />
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <HoursOutTooltip activity={activity} />
      </Popover>
    </Box>
  );
};

export default HoursOutPopover;
